export default __webpack_public_path__ + "images/2b4291d9a50f741470d36178d9f70250.svg";